import { Textarea, type TextareaProps } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { useState } from "react";

type MeteredTextareaProps<T> = Omit<TextareaProps, "onInput" | "form" | "description"> & {
  form: UseFormReturnType<T>;
  path: string;
  maxLength?: number;
};

export function MeteredTextarea<T>({
  form,
  path,
  maxLength,
  inputWrapperOrder = ["label", "input", "description", "error"],
  minRows = 4,
  resize = "vertical",
  ...rest
}: MeteredTextareaProps<T>) {
  const [charCount, setCharCount] = useState(form.getInputProps(path)?.defaultValue?.length || 0);

  return (
    <Textarea
      {...rest}
      minRows={minRows}
      resize={resize}
      key={form.key(path)}
      {...form.getInputProps(path)}
      onInput={(event) => setCharCount(event.currentTarget.value.length)}
      description={maxLength && `${charCount}/${Math.trunc(maxLength)}`}
      inputWrapperOrder={inputWrapperOrder}
    />
  );
}
